import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faCopy, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed, nextTick, ref } from "vue";
import { copy } from "@/utils/clipboard";
import SlugInput from "./SlugInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditableUrl',
    props: {
        prefix: null,
        slug: null
    },
    emits: ["change", "submit"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCopy, faEdit, faCheck);
        const editing = ref(false);
        const slugInput = ref();
        const url = computed(() => props.prefix + props.slug);
        async function onEdit() {
            editing.value = true;
            await nextTick();
            (slugInput.value?.$el).focus();
        }
        function onChange(value) {
            emit("change", value);
        }
        function onSubmit() {
            editing.value = false;
            emit("submit", props.slug);
        }
        const copied = ref(false);
        const clipboardTitle = computed(() => (copied.value ? "Copied!" : "Copy URL"));
        function onCopy() {
            copy(url.value);
            copied.value = true;
        }
        function onCopyOut() {
            copied.value = false;
        }
        return { __sfc: true, props, emit, editing, slugInput, url, onEdit, onChange, onSubmit, copied, clipboardTitle, onCopy, onCopyOut, FontAwesomeIcon, BButton, SlugInput };
    }
});
